import classNames from 'classnames';
import React from 'react';

import styles from './double-loader-scss';

type DoubleLoaderProps = {
  className?: string;
  topArcClassName?: string;
  bottomArcClassName?: string;
};

const d = 'M-4.4 6.07A7.5 7.5 0 1 0 0-7.5';

export const DoubleLoader: React.FC<DoubleLoaderProps> = ({
  className,
  topArcClassName,
  bottomArcClassName,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-9 -9 18 18"
      className={classNames(styles.wrapper, className)}
    >
      <path className={classNames(styles.top, topArcClassName)} strokeWidth="3" d={d} />
      <path className={classNames(styles.bottom, bottomArcClassName)} strokeWidth="3" d={d} />
    </svg>
  );
};
